module.exports = __webpack_public_path__ + "static/media/sf_3300_gray.897d49f077cca6dfd9ff60bf7a7ec0b6.png";